<template>
    <div class="text-uppercase text-center">
        <v-subheader v-if="graph.type == AVG" class="d-block">
            Average {{ graph.prop }}
        </v-subheader>
        <v-subheader v-if="graph.type == SUM" class="d-block">
            Sum {{ graph.prop }}
        </v-subheader>
        <v-subheader v-if="graph.type == MAX" class="d-block">
            {{ graph.prop }} Max
        </v-subheader>
        <v-subheader v-if="graph.type == MIN" class="d-block">
            {{ graph.prop }} Min
        </v-subheader>
        <v-progress-circular
            :rotate="90"
            :size="130"
            :value="(value / (graph.max - graph.min)) * 100"
            :width="12"
            style="font-size: 19px"
            color="accent"
        >
            {{ value }}
        </v-progress-circular>

        <v-divider class="my-6"></v-divider>

        <v-row>
            <v-col
                v-for="line in data.lines"
                :key="line.nline"
                style="font-size: 12px"
                class="pa-0"
            >
                <p class="ma-0">Line {{ line.nline }}</p>
                <v-chip
                    class="ma-2"
                    color="secondary"
                    label
                    text-color="white"
                    style="font-size: 12px"
                >
                    {{ line[graph.prop] }}
                </v-chip>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { AVG, SUM, MAX, MIN } from './props-types'

export default {
    name: 'Widget',
    props: ['data', 'graph'],
    data() {
        return {
            AVG,
            SUM,
            MAX,
            MIN,
            value: null,
        }
    },
    methods: {
        getValue() {
            if (this.graph.type == AVG){
                this.value = (
                    this.data.lines.reduce(
                        (acc, value) => acc + value[this.graph.prop],
                        0
                    ) / this.data.lines.length
                ).toFixed(2)
                return
            }

            if (this.graph.type == SUM){
                this.value = this.data.lines.reduce(
                    (acc, value) => acc + value[this.graph.prop],
                    0
                )
                return
            }

            if (this.graph.type == MAX){
                this.value = Math.max(
                    ...this.data.lines.map((line) => line[this.graph.prop])
                )
                return
            }

            if (this.graph.type == MIN){
                this.value = Math.min(
                    ...this.data.lines.map((line) => line[this.graph.prop])
                )
                return
            }
        },
    },
    watch: { 
      	data(){
            this.getValue()
        }
      }
}
</script>
